module.exports = __webpack_public_path__ + "media/images/svgs/medals-icon-bf0c9cf621d433a28ff705bf8170688d.svg";